// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1200px) {
  .deactivationPeriodWrapper__MCQQQ {
    max-width: 100px;
  }
}

.blockTime__MgWbC {
  display: flex;
  align-items: center;
  text-wrap: nowrap;
  gap: 7px;
}

.scheduledDeactivation__UW9Qp {
  white-space: nowrap;
  margin-bottom: 10px;
}
@media (max-width: 1200px) {
  .scheduledDeactivation__UW9Qp {
    display: none;
  }
}

.reminderBlock__Pgkb9 {
  display: grid;
  grid-template-columns: 16px auto;
  margin-top: 8px;
}

.activationEndDate__Ey0b1,
.activationStartDate__f2aCH {
  min-width: 16px;
}

.activationEndDate__Ey0b1 path {
  stroke: var(--labels-filled-surface-critical);
}

.activationStartDate__f2aCH path {
  stroke: var(--labels-outline-stroke-text-success);
}

.reminderDateIcon__K546w path {
  stroke: var(--tables-primary-row-icon);
}

.firstBlockTime__TnKtu {
  margin-bottom: 5px;
}

.ellipsisTextOneLine__rmGA2 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.ellipsisTextThreeLines__tMpJe {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.reminderTime__gFl8E {
  font-size: 12px;
  line-height: 14px;
  color: var(--tables-primary-row-text-additional);
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageEquipment/components/DeactivationPeriodColumn/style.module.scss"],"names":[],"mappings":"AA2EE;EADF;IAEI,gBAAA;EAzEF;AACF;;AA2EA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;AAxEF;;AA2EA;EACE,mBAAA;EACA,mBAAA;AAxEF;AA0EE;EAJF;IAKI,aAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,gCAAA;EACA,eAAA;AAvEF;;AA0EA;;EAEE,eAAA;AAvEF;;AA0EA;EACE,6CAAA;AAvEF;;AA0EA;EACE,iDAAA;AAvEF;;AA0EA;EACE,sCAAA;AAvEF;;AA0EA;EACE,kBAAA;AAvEF;;AA0EA;EAzEE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAsEA,qBAAA;EACA,aAAA;AAlEF;;AAqEA;EA/EE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA4EA,qBAAA;EACA,aAAA;AA7DF;;AAgEA;EACE,eAAA;EACA,iBAAA;EACA,gDAAA;AA7DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.deactivationPeriodWrapper {\n  @media (max-width: 1200px) {\n    max-width: 100px;\n  }\n}\n.blockTime {\n  display: flex;\n  align-items: center;\n  text-wrap: nowrap;\n  gap: 7px;\n}\n\n.scheduledDeactivation {\n  white-space: nowrap;\n  margin-bottom: 10px;\n\n  @media (max-width: 1200px) {\n    display: none;\n  }\n}\n\n.reminderBlock {\n  display: grid;\n  grid-template-columns: 16px auto;\n  margin-top: 8px;\n}\n\n.activationEndDate,\n.activationStartDate {\n  min-width: 16px;\n}\n\n.activationEndDate path {\n  stroke: var(--labels-filled-surface-critical);\n}\n\n.activationStartDate path {\n  stroke: var(--labels-outline-stroke-text-success);\n}\n\n.reminderDateIcon path {\n  stroke: var(--tables-primary-row-icon);\n}\n\n.firstBlockTime {\n  margin-bottom: 5px;\n}\n\n.ellipsisTextOneLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.ellipsisTextThreeLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.reminderTime {\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--tables-primary-row-text-additional);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deactivationPeriodWrapper": `deactivationPeriodWrapper__MCQQQ`,
	"blockTime": `blockTime__MgWbC`,
	"scheduledDeactivation": `scheduledDeactivation__UW9Qp`,
	"reminderBlock": `reminderBlock__Pgkb9`,
	"activationEndDate": `activationEndDate__Ey0b1`,
	"activationStartDate": `activationStartDate__f2aCH`,
	"reminderDateIcon": `reminderDateIcon__K546w`,
	"firstBlockTime": `firstBlockTime__TnKtu`,
	"ellipsisTextOneLine": `ellipsisTextOneLine__rmGA2`,
	"ellipsisTextThreeLines": `ellipsisTextThreeLines__tMpJe`,
	"reminderTime": `reminderTime__gFl8E`
};
module.exports = ___CSS_LOADER_EXPORT___;
